import { ADVICE_NAMES, Advice } from "Store/advice/interfaces";
import { AdviceIntroDesc, AdviceMessageStyle } from "./styled";

import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { TextLanguage } from "Store/texts/interfaces";
import { isDefined } from "Utils/functions";
import React from "react";
import { useAdviceResult } from "../../hooks/stateSelectors";
import { ChildAdviceIntroMessage } from "./ChildAdviceIntroMessage";
import { generateIntroMessage } from "./utils";

interface Props {
  insurances: {
    name: ADVICE_NAMES;
    title: string;
  }[];
  adviceTexts: any;
  lang: TextLanguage;
}
export const AdviceIntroMessage = ({
  insurances,
  adviceTexts,
  lang,
}: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const adviceResult = useAdviceResult() as Advice;

  const messages = insurances.map((insurance) =>
    generateIntroMessage(
      isAdvisor,
      adviceTexts,
      lang,
      insurance,
      adviceResult.advice[insurance.name],
    ),
  );

  return (
    <AdviceMessageStyle className="AdviceIntroMessages">
      {messages.filter(isDefined).map(({ insuranceType, message }, key) => (
        <AdviceMessageStyle key={`AdviceIntroMessages_${insuranceType}_${key}`}>
          <Description
            fw={600}
            size="16px"
            className="AdviceMessageTitle"
            style={{ marginBottom: 0 }}
          >
            {insuranceType}
          </Description>
          <AdviceIntroDesc fw={400} size="16px" className="AdviceMessageText">
            {message}
          </AdviceIntroDesc>
        </AdviceMessageStyle>
      ))}
      <ChildAdviceIntroMessage
        adviceTexts={adviceTexts}
        lang={lang}
        isCollectiveAdvice={false}
      />
    </AdviceMessageStyle>
  );
};
